// Online/offline detection hook (Task 13.7).
//
// Tracks the browser's connectivity so the app can surface the offline banner
// (Req 29.7) and dismiss it within 2 seconds of coming back online (Req 29.8).
// The `online`/`offline` events fire synchronously on transition, so dismissal
// is effectively immediate.

import { useEffect, useState } from "react";

export function useOnlineStatus(): boolean {
  const [online, setOnline] = useState<boolean>(
    typeof navigator === "undefined" ? true : navigator.onLine,
  );

  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
    };
  }, []);

  return online;
}
